import { render, staticRenderFns } from "./ReportReworksRemarks.vue?vue&type=template&id=2483ee24&"
import script from "./ReportReworksRemarks.vue?vue&type=script&lang=js&"
export * from "./ReportReworksRemarks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QCard,QItemLabel,QTr,QTh,QTd} from 'quasar'
component.options.components = Object.assign({QCard,QItemLabel,QTr,QTh,QTd}, component.options.components || {})
